import { BaseDto } from '../../core';
import { Banner, Product, NoticeBoard, Slot, DisplayCategory, UmmaPick, BestSeller } from '..';
import { BANNER_TYPE, LANGUAGE_TYPE, SLOT_TYPE } from '../../shared';

export interface MappedSlots {
  [SLOT_TYPE.TOP]: Slot[];
  [SLOT_TYPE.BOTTOM]: Slot[];
}

export interface LocaleBanners {
  [LANGUAGE_TYPE.EN]?: {
    [BANNER_TYPE.TOP]?: Banner[];
    [BANNER_TYPE.MIDDLE1]?: Banner[];
    [BANNER_TYPE.MIDDLE2]?: Banner[];
    [BANNER_TYPE.BOTTOM]?: Banner[];
    [BANNER_TYPE.SIGNUP]?: Banner[];
    [BANNER_TYPE.POPUP]?: Banner[];
  };
  [LANGUAGE_TYPE.VI]?: {
    [BANNER_TYPE.TOP]?: Banner[];
    [BANNER_TYPE.MIDDLE1]?: Banner[];
    [BANNER_TYPE.MIDDLE2]?: Banner[];
    [BANNER_TYPE.BOTTOM]?: Banner[];
    [BANNER_TYPE.SIGNUP]?: Banner[];
    [BANNER_TYPE.POPUP]?: Banner[];
  };
}

export interface BrandBanners {
  [LANGUAGE_TYPE.EN]: Banner[];
  [LANGUAGE_TYPE.VI]: Banner[];
}

export class HomeDto extends BaseDto<HomeDto> {
  constructor(partial?: any) {
    super(partial);
  }

  newArrivals: Product[];
  bestSeller: BestSeller[];
  ummaPick: UmmaPick[];
  brandBanner: Banner[];
  banner: {
    [BANNER_TYPE.TOP]?: Banner[];
    [BANNER_TYPE.MIDDLE1]?: Banner[];
    [BANNER_TYPE.MIDDLE2]?: Banner[];
    [BANNER_TYPE.BOTTOM]?: Banner[];
    [BANNER_TYPE.SIGNUP]?: Banner[];
    [BANNER_TYPE.POPUP]?: Banner[];
    [x: string]: Banner[];
  };

  slot: Slot[];
  noticeBoard: NoticeBoard[];

  bannerTypes = [
    BANNER_TYPE.TOP,
    BANNER_TYPE.MIDDLE1,
    BANNER_TYPE.MIDDLE2,
    BANNER_TYPE.BOTTOM,
    BANNER_TYPE.SIGNUP,
    BANNER_TYPE.POPUP,
  ];

  mappedSlots: MappedSlots = {
    [SLOT_TYPE.TOP]: [],
    [SLOT_TYPE.BOTTOM]: [],
  };

  brandBanners: BrandBanners = {
    [LANGUAGE_TYPE.EN]: [],
    [LANGUAGE_TYPE.VI]: [],
  };
  localeBanners: LocaleBanners = {
    [LANGUAGE_TYPE.EN]: {
      [BANNER_TYPE.TOP]: [],
      [BANNER_TYPE.MIDDLE1]: [],
      [BANNER_TYPE.MIDDLE2]: [],
      [BANNER_TYPE.BOTTOM]: [],
      [BANNER_TYPE.SIGNUP]: [],
      [BANNER_TYPE.POPUP]: [],
    },
    [LANGUAGE_TYPE.VI]: {
      [BANNER_TYPE.TOP]: [],
      [BANNER_TYPE.MIDDLE1]: [],
      [BANNER_TYPE.MIDDLE2]: [],
      [BANNER_TYPE.BOTTOM]: [],
      [BANNER_TYPE.SIGNUP]: [],
      [BANNER_TYPE.POPUP]: [],
    },
  };

  setLocaleBanner() {
    this.bannerTypes.forEach((type) => {
      // tslint:disable-next-line:no-unused-expression
      this.banner[type] &&
        this.banner[type].forEach((banner) => {
          if (banner.data[LANGUAGE_TYPE.EN]) {
            this.localeBanners[LANGUAGE_TYPE.EN][type].push(banner);
          }
          if (banner.data[LANGUAGE_TYPE.VI]) {
            this.localeBanners[LANGUAGE_TYPE.VI][type].push(banner);
          }
        });
    });
    return this.localeBanners;
  }
  setBrandBanner() {
    this.brandBanner.forEach((banner) => {
      if (banner.data[LANGUAGE_TYPE.EN]) {
        this.brandBanners[LANGUAGE_TYPE.EN].push(banner);
      }
      if (banner.data[LANGUAGE_TYPE.VI]) {
        this.brandBanners[LANGUAGE_TYPE.VI].push(banner);
      }
    });
    return this.brandBanners;
  }

  initialSlots() {
    this.slot.map((item) => {
      if (item.slotType === SLOT_TYPE.TOP) {
        this.mappedSlots.TOP.push(item);
      } else {
        this.mappedSlots.BOTTOM.push(item);
      }
    });
    return this.mappedSlots;
  }
}
